module.exports = __webpack_public_path__ + "img/face_ugly.5e758f11.svg";